import { AppDispatch } from 'store/index';
import {
  needUpdateAction,
  setBackdropLoadingAction,
} from 'store/actions/mainPage';
import { searchTabSlice } from 'store/reducers/searchTab';
import { exampleATE, exampleParams } from 'store/actions/searchTab/constants';
import {
  IPoint,
  ISearchParamName,
  ISelectATE,
  ISelectedATE,
} from 'types/mainPage';
import { httpClient, httpConfig } from 'utils/httpClient';
import { LanguageService } from 'services/languageService';
import { setLastAteParams } from '../layers/constants';
import { layersSlice } from 'store/reducers/layers';
import { mainPageSlice } from 'store/reducers/mainPage';
const URL = process.env.REACT_APP_API_URL;

export const getSelectAteAction = () => (dispatch: AppDispatch) => {
  dispatch(searchTabSlice.actions.setSelectAte(exampleATE));
};

export const setCurrentAteAction =
  (ate: ISelectATE) => (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.setCurrentAte(ate));
  };

export const getParamNamesAction = () => (dispatch: AppDispatch) => {
  dispatch(searchTabSlice.actions.setParamNames(exampleParams));
};

export const setCurrentParamAction =
  (param: ISearchParamName) => (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.setCurrentParam(param));
  };

export const setSearchRequestAction =
  (request: string) => (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.setSearchRequest(request));
  };

export const setSearchingAction =
  (searching: boolean) => (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.setSearching(searching));
  };

export const resetSearchBlockAction = () => (dispatch: AppDispatch) => {
  dispatch(searchTabSlice.actions.resetSearchBlock());
};

export const getSearchListsAction =
  (lang: string) => async (dispatch: AppDispatch) => {
    const urlForm = `${URL}/api/listlegalforms`;
    const urlActivities = `${URL}/api/listeactivities`;

    const resForm = await httpClient.post(
      urlForm,
      new URLSearchParams({ lang }),
      httpConfig
    );

    const resActivities = await httpClient.post(
      urlActivities,
      new URLSearchParams({ lang }),
      httpConfig
    );

    const legalForm = resForm.data.data.map((item) => {
      return { ...item, label: item.name };
    });

    const activities = resActivities.data.data.map((item) => {
      return { ...item, label: item.name };
    });

    dispatch(
      searchTabSlice.actions.setLists({
        legalForm,
        activities,
      })
    );
  };

export const setCurrentLegalFormAction =
  (ids: number[]) => (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.setCurrentLegalForm(ids));
  };

export const setCurrentActivityAction =
  (ids: string[]) => (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.setCurrentActivity(ids));
  };

export const setPointsAction =
  (points: IPoint[]) => (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.setFoundPoints(points));
  };

export const setAllPointsAction =
  (allPoints: any[]) => (dispatch: AppDispatch) => {
    dispatch(searchTabSlice.actions.setAllFoundPoints(allPoints));
  };

export const getClusterInfoAction =
  (gid: string, coord: number[]) => async (dispatch: AppDispatch) => {
    const url = `${URL}/api/getcompany`;
    const lang = LanguageService.getLanguage();
    const params = { gid, lang };
    dispatch(setBackdropLoadingAction(true));
    const res = await httpClient.post(
      url,
      new URLSearchParams(params),
      httpConfig
    );

    dispatch(
      searchTabSlice.actions.setClusterInfo({
        gid,
        info: res.data.data,
        coordinates: coord,
      })
    );
    dispatch(setBackdropLoadingAction(false));
  };

export const resetClusterInfoAction = () => (dispatch: AppDispatch) => {
  dispatch(searchTabSlice.actions.resetClusterInfo());
};

export const resetBusinessEntityDataAction = () => (dispatch: AppDispatch) => {
  dispatch(searchTabSlice.actions.resetBEData());
};

export const resetPointsAction = () => (dispatch: AppDispatch) => {
  dispatch(searchTabSlice.actions.setFoundPoints([]));
  dispatch(searchTabSlice.actions.setAllFoundPoints([]));
};

export const langUpdateMultipleAteActionBE =
  (region: ISelectedATE[] | null, city: ISelectedATE[] | null) =>
  async (dispatch: AppDispatch) => {
    dispatch(setBackdropLoadingAction(true));
    const ateUrl = `${URL}/api/listate`;
    const lang = LanguageService.getLanguage();

    const resRegion = await httpClient.post(
      ateUrl,
      new URLSearchParams({ lang }),
      httpConfig
    );

    const listRegion = resRegion.data.data.map((item) => {
      return { ...item, label: item.name };
    });

    dispatch(
      layersSlice.actions.setAte({ param: 'ateRegions', ate: listRegion })
    );

    if (region?.length) {
      const params = setLastAteParams(
        {
          regions: region,
          cities: city,
          vc: null,
        },
        true
      );
      const resCities = await httpClient.post(
        ateUrl,
        new URLSearchParams(params),
        httpConfig
      );

      const listCities = resCities.data.data.map((item) => {
        return { ...item, label: item.name };
      });

      const currentRegions: any = [];

      region.forEach((reg) => {
        listRegion.forEach((listReg) => {
          if (reg.id === listReg.id && reg.type === listReg.type) {
            currentRegions.push(listReg);
          }
        });
      });

      dispatch(
        layersSlice.actions.setAte({ param: 'ateCities', ate: listCities })
      );
      dispatch(
        mainPageSlice.actions.setCurrentStat({
          param: 'currentAteRegions',
          value: currentRegions,
        })
      );

      if (city?.length) {
        const currentCities: any = [];

        city.forEach((cit) => {
          listCities.forEach((listCit) => {
            if (cit.id === listCit.id && cit.type === listCit.type) {
              currentCities.push(listCit);
            }
          });
        });

        dispatch(
          mainPageSlice.actions.setCurrentStat({
            param: 'currentAteCities',
            value: currentCities,
          })
        );
      }
    }

    dispatch(setBackdropLoadingAction(false));
    dispatch(needUpdateAction(false));
  };
